@if (moiModel) {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'detailMain.detailsTitle' | t }}</div>
        <form
            [formGroup]="parentForm"
            class="detail-page-card-body padded cerrix-control-sm form-group-styling"
            novalidate
            data-uiid="moi-detail-form"
        >
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <cerrix-textfield
                                    [fieldLabel]="'detailMain.nameLabel' | t"
                                    dataUiid="moi-name"
                                    identifier="nameInput"
                                    placeholder="Required"
                                    formControlName="Name"
                                    [required]="true"
                                ></cerrix-textfield>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="form-group">
                                <label for="subjectSelect">{{ 'detailMain.subjectLabel' | t }}</label>
                                <ng-select
                                    data-uiid="moi-subject"
                                    id="subjectSelect"
                                    name="subjectSelect"
                                    [items]="sd.Subjects"
                                    formControlName="Subject"
                                    placeholder="Required"
                                    bindLabel="Name"
                                    bindValue="ID"
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="subjectSelect">{{ 'detailMain.priorityLabel' | t }}</label>
                                <ng-select
                                    data-uiid="moi-priority"
                                    id="prioritySelect"
                                    name="prioritySelect"
                                    [items]="sd.Priorities"
                                    placeholder="Required"
                                    formControlName="Priority"
                                    bindLabel="Name"
                                    bindValue="ID"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="implementationSelect">{{ 'detailMain.implementationScoreLabel' | t }}</label>
                                <ng-select
                                    data-uiid="moi-implementationscore"
                                    id="implementationSelect"
                                    name="implementationSelect"
                                    [items]="sd.ImplementationScores"
                                    formControlName="ImplementationScore"
                                    bindLabel="Name"
                                    bindValue="ID"
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <div
                                            [style.background-color]="item.Color"
                                            style="
                                                min-width: 5px;
                                                min-height: 16px;
                                                float: left;
                                                margin-right: 10px;
                                            "
                                        ></div>
                                        {{ item.Name }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'detailMain.startDateLabel' | t }}</label>
                                <date-input
                                    data-uiid="moi-startdate"
                                    formControlName="StartDate"
                                ></date-input>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'detailMain.dueDateLabel' | t }}</label>
                                <date-input data-uiid="moi-duedate" formControlName="DueDate">
                                </date-input>
                                @if (parentForm?.controls?.DueDate?.errors) {
                                    <div class="red">
                                        @if (
                                            parentForm?.controls?.DueDate?.errors
                                                .StartDateAfterDueDate
                                        ) {
                                            <p>
                                                {{
                                                    parentForm?.controls?.DueDate?.errors
                                                        .StartDateAfterDueDate
                                                }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="form-group col">
                            <label for="orgResponsible">
                                {{ 'detailMain.orgResponsibleLabel' | t }}
                                @if (
                                    permissions.canAppointResponsible &&
                                    ((moiModel.LinkedControls &&
                                        moiModel.LinkedControls.length > 0) ||
                                        (moiModel.LinkedRisks && moiModel.LinkedRisks.length > 0))
                                ) {
                                    <i
                                        class="far fa-question-circle"
                                        matTooltip="There are linked risks or controls that are dependant on this organization. To change the organization responsible remove these links first."
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="moi-organizationresponsible"
                                [tree]="sd.ResponsibleOrganizations"
                                formControlName="OrganizationResponsible"
                                (onChangeSingleId)="moiModel.OrganizationResponsible = $event"
                                placeholder="Required"
                                [multiselect]="false"
                            >
                            </cerrix-select-tree>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <label for="responsibleSelect">{{ 'detailMain.responsibleLabel' | t }}</label>
                            <ng-select
                                data-uiid="moi-responsible"
                                id="responsibleSelect"
                                name="responsibleSelect"
                                [multiple]="true"
                                [items]="validResponsibles"
                                placeholder="Required"
                                formControlName="Responsibles"
                                bindLabel="Name"
                                bindValue="ID"
                                [closeOnSelect]="false"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <label for="delegateSelect">{{ 'detailMain.delegatesLabel' | t }}</label>
                            <ng-select
                                data-uiid="moi-delegate"
                                id="delegateSelect"
                                name="delegateSelect"
                                [multiple]="true"
                                [items]="validDelegates"
                                formControlName="Delegates"
                                bindLabel="Name"
                                bindValue="ID"
                                [closeOnSelect]="false"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <label for="businessDimension"> {{ 'detailMain.businessDimensionsLabel' | t }} </label>
                            @if (moiModel.Id || permissions.canChangeBusinessDimensions) {
                                <cerrix-select-tree
                                    data-uiid="moi-businessdimensions"
                                    [tree]="sd.BusinessDimensions"
                                    formControlName="BusinessDimensions"
                                    [multiselect]="true"
                                >
                                </cerrix-select-tree>
                            } @else {
                                <div>
                                    <small
                                        >{{ 'detailMain.businessDimensionsInherited' | t }}</small
                                    >
                                </div>
                            }
                        </div>
                    </div>
                    @if (moiModel.Type != MoiTypes.LER_Moi) {
                        <div class="row">
                            <div class="form-group col">
                                <label for="frameworkDimension"> {{ 'detailMain.frameworkDimensionsLabel' | t }} </label>
                                @if (moiModel.Id || permissions.canChangeFrameworkDimensions) {
                                    <cerrix-select-tree
                                        data-uiid="moi-frameworkdimensions"
                                        [tree]="sd.FrameworkDimensions"
                                        formControlName="FrameworkDimensions"
                                        [multiselect]="true"
                                    >
                                    </cerrix-select-tree>
                                } @else {
                                    <div>
                                        <small
                                            >{{ 'detailMain.frameworkDimensionsInherited' | t }}</small
                                        >
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    <hr />

                    <div class="row">
                        <div class="form-group col">
                            <label>{{ 'detailMain.orgReviewerLabel' | t }}</label>
                            <cerrix-select-tree
                                data-uiid="moi-organizationreviewer"
                                [tree]="sd.ReviewerOrganizations"
                                formControlName="OrganizationReviewer"
                                placeholder="Required"
                                [multiselect]="false"
                            >
                            </cerrix-select-tree>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col">
                            <label>{{ 'detailMain.reviewerLabel' | t }}</label>
                            <ng-select
                                data-uiid="moi-reviewer"
                                name="reviewerSelect"
                                [multiple]="true"
                                [items]="validReviewers"
                                placeholder="Required"
                                formControlName="Reviewers"
                                bindLabel="Name"
                                bindValue="ID"
                                [closeOnSelect]="false"
                            >
                            </ng-select>
                        </div>
                    </div>

                    <hr class="d-xl-none" />
                </div>
                <div class="col-12 col-xl-6 right-block">
                    <div class="row">
                        <div class="form-group col">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.findingDescriptionLabel' | t"
                                dataUiid="moi-findingdescription"
                                identifier="findingDescriptionInput"
                                [rows]="9"
                                formControlName="FindingDescription"
                            ></cerrix-textarea>
                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="form-group col">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.recommendationLabel' | t"
                                dataUiid="moi-recommendation"
                                identifier="recommendationInput"
                                [placeholder]="'detailMain.recommendationPlaceholder' | t"
                                [rows]="9"
                                formControlName="Recommendation"
                                [required]="true"
                            ></cerrix-textarea>
                        </div>
                    </div>

                    <hr />

                    <div class="row">
                        <div class="form-group col">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.managementResponseLabel' | t"
                                dataUiid="moi-managementresponse"
                                identifier="managementResponseInput"
                                [rows]="9"
                                formControlName="ManagementResponse"
                            ></cerrix-textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <label for="Url">{{ 'detailMain.moiUrlLabel' | t }}</label>
                            <cerrix-url-input
                                dataUiid="moi-url"
                                id="Url"
                                name="Url"
                                formControlName="Url"
                            ></cerrix-url-input>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
}

@if (parentSummary) {
    <div>
        @switch (moiModel.Type) {
            @case (MoiTypes.IM_Moi) {
                <moi-finding-report-summary
                    [summaryModel]="parentSummary"
                    [showOpenButton]="parentSummary.CanOpenParent"
                    [moi]="moiModel"
                    [canLink]="permissions.canAddFindingReportAssessment"
                >
                </moi-finding-report-summary>
            }
            @case (MoiTypes.Control_Moi) {
                <control-detail-overview
                    [ControlGuid]="moiModel.ParentGuid"
                    [HideOpenControlButton]="!parentSummary.CanOpenParent"
                    [ParentModule]="ModuleType"
                    [ParentGuid]="moiModel.Guid"
                    Label="Linked Control"
                >
                </control-detail-overview>
            }
            @case (MoiTypes.LER_Moi) {
                <moi-event-summary [summaryModel]="parentSummary" [eventID]="moiModel.ParentGuid">
                </moi-event-summary>
            }
            @case (MoiTypes.RISK_Moi) {
                <moi-risk-summary [summaryModel]="parentSummary" [riskGuid]="moiModel.ParentGuid">
                </moi-risk-summary>
            }
            @case (MoiTypes.TP_Moi) {
                <moi-thirdparty-summary
                    [summaryModel]="parentSummary"
                    [thirdpartyGUID]="moiModel.ParentGuid"
                >
                </moi-thirdparty-summary>
            }
            @case (MoiTypes.DM_Moi) {
                <moi-processing-purpose-summary
                    [summaryModel]="parentSummary"
                    [processingPurposeID]="moiModel.ParentGuid"
                >
                </moi-processing-purpose-summary>
            }
            @case (MoiTypes.Incident_Moi) {
                <moi-incident-summary
                    [summaryModel]="parentSummary"
                    [incidentGuid]="moiModel.ParentGuid"
                >
                </moi-incident-summary>
            }
        }
    </div>
}
